import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  offerCard: ({ isActive }: { isActive: boolean }) => ({
    flexDirection: "column",
    gap: spacing(2),
    padding: spacing(4),
    borderWidth: border.widths.md,
    borderColor: colors.borderDefault,
    borderRadius: border.radius.lg,
    ...(isActive && {
      borderWidth: border.widths.md,
      borderColor: colors.borderBrand,
    }),
  }),
  offerDescription: {
    marginTop: spacing(2),
  },
  offerPrice: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: spacing(3),
    marginBottom: spacing(2),
  },
}));

export default stylesheet;
